module.exports = __webpack_public_path__ + "img/platinumGold@2x.a3f46eb.webp";